// languagetools:disable
import { AuthorizationStatusEnum, type TLocationSettingsType } from '../../../types/tracking'

interface IMobileTrackingIssueLabelsParams {
  isDeviceNotDetected?: boolean
  isLoggedIn?: boolean
  isTrackingOn?: boolean
  locationSettings: TLocationSettingsType | null
}

/**
 * Build concise issue labels for the mobile tracking source summary row.
 */
export const getMobileTrackingIssueLabels = ({
  isDeviceNotDetected,
  isLoggedIn,
  isTrackingOn,
  locationSettings
}: IMobileTrackingIssueLabelsParams): string[] => {
  const labels = new Set<string>()

  const authStatus = locationSettings?.authorizationStatus

  // Permission level
  const hasBackgroundPermission = authStatus === AuthorizationStatusEnum.AuthorizationStatusAlways
  const hasForegroundOnlyPermission = authStatus === AuthorizationStatusEnum.AuthorizationStatusWhenInUse
  // Any status that isn't Always or WhenInUse means GPS access is denied/restricted/unknown
  const hasGPSPermissionDenied = !!authStatus && !hasBackgroundPermission && !hasForegroundOnlyPermission

  // Hardware/OS level — independent of permission
  const isLocationServiceOff = locationSettings?.locationServicesEnabled === false
  const isGPSProviderUnavailable = locationSettings?.gpsGeolocationProviderAvailable === false
  const isHardwareUsable = !isLocationServiceOff && !isGPSProviderUnavailable

  if (hasForegroundOnlyPermission) {
    // Permission grants foreground access, but the hardware stack may still be off.
    labels.add(isHardwareUsable ? 'GPS enabled' : 'GPS disabled')
    labels.add('Background location off')
  }

  if (hasGPSPermissionDenied || isLocationServiceOff || isGPSProviderUnavailable) {
    labels.add('GPS disabled')
  }

  if (isLoggedIn === false) {
    labels.add('Logged out')
  }

  if (isTrackingOn === false) {
    labels.add('Off duty')
  }

  if (isDeviceNotDetected) {
    labels.add('Device not detected')
  }

  return Array.from(labels)
}
